<template>
   <div id="bnfhpicture">
      <commonHeader></commonHeader>
        <!--每一个时期的位置-->
        <div tyle="width:100%;height:240px;">
           <div id="historymap" style="width:100%;z-index:8;"  v-bind:style="{ height: mapheightSize + 'px' }"></div>
        </div>
   </div>
</template>

<script>
import commonHeader from "./../components/common-header.vue";
import cfg from "./../utils/config";
import Addr from "./../utils/getAPI";
import axios from "axios";
export default {
    name:'bnfhpicture',
    props:{
        id:{
            type:Number,
          
        }
    },
    data(){
        return{
              mapheightSize: 240,
        }

    },
    components: {
    
        commonHeader,
    
    },
    created:function(){
     
  
   
   },
    mounted: function() {
     if (window.innerWidth > cfg.widthLimit) {
      this.heightSize = 360;
    }
     console.log('图片id',this.props)

    axios
      .get(Addr.getGoNewAPIPrefix() + "sizheng/listSizhengSchools")
      .then(res => {
        console.log("sizheng school res is:");
        console.log(res);
        if (res.status == 200) {
          console.log("200");
          this.schools=res.data;

          this.mapInit();
        }
      })
      .catch(err => {
        console.log(err);
      });

    },
    methods:{
    mapInit() {
      let map = L.map("historymap", {
        center: [45.74740199642105, 126.65817975997926],
        zoom: 11
      });
      // 影像
      L.tileLayer(
        "http://t{s}.tianditu.com/img_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 地名标注
      L.tileLayer(
        "http://t{s}.tianditu.com/cia_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cia&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);
      // 边界
      L.tileLayer(
        "http://t{s}.tianditu.com/ibo_w/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=ibo&tileMatrixSet=w&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=b256e08b9f972a2c4677ab5608a305ff",
        {
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"]
        }
      ).addTo(map);

      let _self = this;

      console.log(_self.schools);

      _self.schools.forEach(item => {
        var linkComponent = Vue.extend({
          // template: '<a @click="goArea('+item.name+','+item.img+')">' + item.name + '</a>',
          template: '<a @click="goArea()">' + item.name + "</a>",
          methods: {
            goArea() {
              //window.location.href = item.link;
              openUrl.open(item.link);
            }
          }
        });
        var component = new linkComponent().$mount();

        var name = item.name;
        var marker = L.marker([item.latitude, item.longitude])
          .addTo(map)
          .bindPopup(
            component.$el
            // '<a>' + item.name + '</a>'

            // '<a href="' +
            // item.link +
            // "?name=" +
            // encodeURI(item.name) +
            // "&img=" +
            // item.img +
            // '">' +
            // item.name +
            // "></a>"
          );
      });
    }

    }
  
    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/module-clickbnfhPicture/index.vue